/**
 * Sessão do link público de pagamento flex (`/p/:token`).
 *
 * O paciente entra sem login: confirma o CPF uma vez e recebe um JWT curto, guardado
 * no `sessionStorage` da aba. Quando ele expira, **o portal precisa saber disso pelo
 * código, não pela mensagem** — texto muda, e comparar frase é como o portal acabava
 * pedindo um CPF que ele mesmo não tinha como oferecer.
 */
/**
 * A sessão do link flex acabou (ou nunca foi válida). Quem recebe deve **descartar a
 * sessão local** e voltar ao portão de CPF — não basta exibir a mensagem: a tela que
 * continua se achando autenticada não oferece onde digitar o CPF de novo.
 */
export const FLEX_SESSION_EXPIRED_CODE = 'FLEX_SESSION_EXPIRED';
/**
 * Payload de erro do backend. O `code` é o contrato; a `message` é só para o humano.
 *
 * ⚠️ **Sem campo `error`.** O cliente HTTP resolve o código como
 * `data.error || data.code`, então um `error: 'Unauthorized'` — como o que outras
 * exceções do repo incluem — passaria na frente e o portal nunca veria
 * `FLEX_SESSION_EXPIRED`.
 */
export const FLEX_SESSION_EXPIRED_ERROR = {
    message: 'Sua sessão expirou. Confirme o CPF novamente para continuar.',
    code: FLEX_SESSION_EXPIRED_CODE,
};
//# sourceMappingURL=index.js.map